export const IS_PRODUCTION =
  process.env.GF_ORIGIN === 'https://hoshinoresorts.com' ||
  process.env.GF_ORIGIN === 'https://gf-acco-cms.hoshinoresorts.com';

export const IS_STAGING =
  process.env.GF_ORIGIN === 'https://stg.hoshinoresorts.com';

export const IS_TEST =
  process.env.GF_ORIGIN === 'https://test.hoshinoresorts.com';

export const IS_DEV = process.env.GF_DEVELOPMENT === '1';

export const IS_PRODUCTION_IGNORE = IS_PRODUCTION || IS_STAGING;
